import { useState } from "react";
import { Eye, EyeOff, Check } from "lucide-react";

export default function KipaInput({
  label,
  placeholder,
  value,
  onChange,
  type = "text",
  inputMode,
  keyboardType,
  secureTextEntry = false,
  showPasswordToggle = false,
  helperText,
  errorText,
  successCondition,
  maxLength,
  multiline = false,
  rows = 3,
  testId,
  autoCapitalize,
  className = "",
  ...rest
}) {
  const [show, setShow] = useState(false);
  const [focused, setFocused] = useState(false);
  const isPassword = secureTextEntry || type === "password";
  const inputType = isPassword && !show ? "password" : type === "password" ? "text" : type;
  const hasValue = String(value ?? "").length > 0;
  const isSuccess = !errorText && hasValue && successCondition?.(value);
  const stateClass = errorText
    ? "kipa-input-error"
    : isSuccess
      ? "kipa-input-success"
      : focused
        ? "kipa-input-focused"
        : "";

  const inputProps = {
    value,
    onChange,
    placeholder,
    maxLength,
    "data-testid": testId,
    className: `kipa-input-field ${showPasswordToggle || isSuccess ? "kipa-input-field-padded" : ""}`,
    onFocus: () => setFocused(true),
    onBlur: () => setFocused(false),
    inputMode: inputMode || (keyboardType === "decimal-pad" ? "decimal" : keyboardType === "numeric" || keyboardType === "number-pad" ? "numeric" : keyboardType === "tel" || keyboardType === "phone-pad" ? "tel" : keyboardType === "email" ? "email" : undefined),
    autoCapitalize,
    ...rest,
  };

  return (
    <div className={`kipa-input-wrap ${className}`}>
      {label && <label className="kipa-input-label">{label}</label>}
      <div className={`kipa-input-box ${stateClass}`}>
        {multiline ? (
          <textarea rows={rows} {...inputProps} />
        ) : (
          <input type={inputType} {...inputProps} />
        )}
        {showPasswordToggle && isPassword && (
          <button
            type="button"
            className="kipa-input-toggle"
            onClick={() => setShow((s) => !s)}
            aria-label={show ? "Hide password" : "Show password"}
          >
            {show ? <EyeOff size={20} /> : <Eye size={20} />}
          </button>
        )}
        {isSuccess && !showPasswordToggle && (
          <span className="kipa-input-check" aria-hidden>
            <Check size={16} />
          </span>
        )}
      </div>
      {errorText && <p className="kipa-input-error-text">{errorText}</p>}
      {!errorText && helperText && <p className="kipa-input-helper">{helperText}</p>}
    </div>
  );
}
